import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

const NextContact: FC<{ nextContact: Date | null }> = ({ nextContact }) => {
  const { t } = useTranslation(['assignments'])

  return (
    <p>
      <b>{t('card.next-contact.description')}:</b>
      {` `}
      {nextContact
        ? t('card.next-contact.date-formatted', {
            date: nextContact,
          })
        : '-'}
    </p>
  )
}

export { NextContact }
